<script setup lang="ts"></script>

<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" height="83" viewBox="0 0 218 83" fill="none">
      <path
        class="accent"
        d="M1.3331 17.7885C0.112023 18.433 -0.355421 19.9453 0.289038 21.1664C0.933497 22.3875 2.44582 22.8549 3.6669 22.2104L1.3331 17.7885ZM208.362 82.9172C209.697 83.2693 211.065 82.4725 211.417 81.1375L217.156 59.3816C217.508 58.0465 216.711 56.6788 215.376 56.3266C214.041 55.9745 212.673 56.7713 212.321 58.1063L207.22 77.4449L187.882 72.3439C186.547 71.9918 185.179 72.7886 184.827 74.1236C184.475 75.4587 185.271 76.8264 186.606 77.1786L208.362 82.9172ZM2.5 19.9995L3.6669 22.2104C18.318 14.4779 53.5905 2.49684 92.9705 5.92744C132.19 9.34402 175.543 28.0355 206.84 81.7583L209 80.4999L211.16 79.2414C178.957 23.9634 134.06 4.48804 93.4045 0.946302C52.9095 -2.58142 16.682 9.6877 1.3331 17.7885L2.5 19.9995Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
div {
  max-width: 218px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: rgb(var(--v-theme-on-surface-high-xqes));
    width: 100%;
    height: auto;

    .accent {
      color: rgb(var(--v-theme-brand-accent-xqes));
    }
  }
}
</style>
